import axios from 'axios'
import Cookies from "js-cookie";

import { FLTOPS_BACKEND, MXOPS_BACKEND } from './config';

export const createMxopsClient = ({ url, config = {} }) => {
  return axios.create({
    ...config,
    baseURL: `${MXOPS_BACKEND}${url}`,
    headers: { 'X-CSRFToken': Cookies.get('mxopscsrftoken') },
  });
};

export const createFltopsClient = ({ url, config = {} }) => {
  return axios.create({
    ...config,
    baseURL: `${FLTOPS_BACKEND}${url}`,
    headers: { 'X-CSRFToken': Cookies.get('fltopscsrftoken') },
  });
};

export const commonApi = createFltopsClient({ url: '' });
export const hiringApi = createFltopsClient({ url: '/hiring/api' });
export const dispatchApi = createFltopsClient({ url: '/dispatch/api' });
export const flightApi = createFltopsClient({ url: '/flight/api' });

export const getDepartments = () => commonApi.get('/account/api/user-profile/public/department/');
export const getDepartmentHeads = () => commonApi.get('/account/api/user-profile/public/department-heads/');
export const getAirports = () => flightApi.get('/public/airports/');
export const getRepairStations = () => flightApi.get('/public/repair-stations/');

export const mxCommonApi = createMxopsClient({ url: '' });
export const nonRoutineApi = createMxopsClient({ url: '/public/non-routine' });
export const maintenanceApi = createMxopsClient({ url: '/public/maintenance' });
export const complianceApi = createMxopsClient({ url: '/public/completed-item' });

export const getReturnToServices = () => mxCommonApi.get('public/return-to-service');
export const getRemovalStatus = () => mxCommonApi.get('public/removal-status');


export const maintenanceClient = {
  getCompliance: ({ uid, data }) => maintenanceApi.post(`/${uid}/compliance/`, data),
};
export const complianceClient = {
  create: ({ data }) => complianceApi.post('/', data),
};
